export interface EventDetailsRequestData {
  event: string;
  source?: SourceType;
  /** 'status' asks for only the status fields of each session. */
  fields?: 'status';
}

export type SourceType = 'secondScreenAgenda';

export interface EventDetailsResponseData {
  success: boolean;
  data: SessionDetail[];
  error: Error; // TODO: @SYN-83 check if the correct type is Error
}

export interface SessionDetail {
  EndsAt: string;
  GenerateInsights: boolean;
  Event: string;
  Track: string;
  SessionTitle: string;
  SessionId: string;
  SpeakersInfo: Speaker[];
  SessionDescription: string;
  Status: SessionStatus;
  Type: SessionType;
  sid: number;
  PrimarySessionId: string;
  EventDay: EventDayEnum;
  Format: string;
  Location: string;
  SessionSubject: string;
  StartsAt: Date;
  hasBreakoutSessions?: boolean;
}

export interface Speaker {
  Name: string;
  Title: string;
  Url: string;
  Organization: string;
  isModerator: boolean;
}

export enum EventDayEnum {
  Day1 = 'Day 1',
  Day2 = 'Day 2',
  Day3 = 'Day 3',
}

export type SessionStatus =
  | SessionStatusEnum.NotStarted
  | SessionStatusEnum.InProgress
  | SessionStatusEnum.Paused
  | SessionStatusEnum.ProcessingInsights
  | SessionStatusEnum.UnderReview
  | SessionStatusEnum.ReviewComplete;

export enum SessionStatusEnum {
  NotStarted = 'NOT_STARTED',
  InProgress = 'IN_PROGRESS',
  Paused = 'PAUSED',
  ProcessingInsights = 'PROCESSING_INSIGHTS',
  UnderReview = 'UNDER_REVIEW',
  ReviewComplete = 'REVIEW_COMPLETE',
}

export type SessionType =
  | SessionTypeEnum.PrimarySession
  | SessionTypeEnum.BreakoutSession
  | SessionTypeEnum.Keynote
  | SessionTypeEnum.Presentation;

export enum SessionTypeEnum {
  PrimarySession = 'PrimarySession',
  BreakoutSession = 'BreakoutSession',
  Keynote = 'Keynote',
  Presentation = 'Presentation',
}
